module.exports = __webpack_public_path__ + "img/female-elderly-hand.fc5975f4.svg";